import React, { useState, useEffect } from 'react';

const ReportDashboardPage = () => {
    
    return (
         <div className='mt-5' style={{minHeight: '100vh', backgroundColor: '#F8F9FA'}}>
            <iframe 
              title="Drive Off Shield Dashboard" 
              width="100%"
              height="800vh"
              src="https://app.powerbi.com/view?r=eyJrIjoiZjYzNGIxMWMtMzExNS00MGViLTgwZDEtNjU5MWYyZTM5OTUzIiwidCI6IjZhNTFjNjAxLTllNTctNDUzYy04YTU2LWJiMjEzOGQ2MGYyOCJ9" 
              frameborder="0" 
              style={{marginTop: '40px'}}
              allowFullScreen="true">
            </iframe>

        </div>
    );
}
      
export default ReportDashboardPage;

